<template>
  <div>
    <span class="pull-right">{{$t('notifications.noClient')}}
      <i class="fa fa-1x fa-question-circle ml-1 mb-1 mr-3" style="color:#0090CD" :content="$t('settings.infoNoClient')" v-tippy="{ placement : 'right',  arrow: true }"/>
        <b-button class="typo-butt-add mr-2 but-add"  @click="handleModal ">
          {{$t("settings.manageClient")}}
        </b-button>
    </span>

    <!-- Gestisci cliente proprietario modal -->
    <b-modal
      no-close-on-backdrop
      size="lg"
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-manage-client"
      :title="$t('settings.manageClientTitle')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      :ok-disabled="!saveEnabled"
      @ok="handleOk"
    >

    <!-- Amministratore e proprietario -->
    <b-form-radio class="m-3" type="radio" id="client_admin" value="Admin" v-model="picked_client">
    <label for="client_admin">{{$t("manage_client_modal.client_admin")}}</label>
    </b-form-radio>
    <hr>
    
    <!--Invia invito a proprietario per accesso a nube  
    //Sezione rimossa , invito cliente solo da pagina Utenti
    <b-form-radio class="m-3" type="radio" id="client_invite" value="Invite" v-model="picked_client">
    <label for="client_invite">{{$t("manage_client_modal.client_invite")}}</label>
    </b-form-radio>
    <div class="mr-5 ml-5" v-if="this.picked_client=='Invite'">  
        <b-form-input v-model="mailInvitato" type="email" :placeholder='$t("settings.insertMailOwner")'></b-form-input>
        <br>
    </div>    
    <hr>  -->

    <!-- Inserimento anagrafica proprietario -->
    <b-form-radio class="m-3" type="radio" id="client_anag" value="Anag" v-model="picked_client">
    <label for="client_anag">{{$t("manage_client_modal.client_anag")}}</label>
    </b-form-radio>

    <div v-if="this.picked_client=='Anag'">  
      <b-form-group class="ml-5">
          <b-row>
           <b-col sm="12">
               <b-form-group class="m-3">
                  <b-form-radio class="ml-4 mb-2" v-model="type_anag" name="PersonComp" value="company">{{$t("user_modal.label_company")}}</b-form-radio>
                  <b-form-radio class="ml-4 mb-2" v-model="type_anag" name="PersonComp" value="person">{{$t("user_modal.label_people")}}</b-form-radio>
               </b-form-group>
           </b-col> 
           <b-col sm="5" class="mr-1">
                <b-form-group v-if="type_anag=='person'">
                    <label for="label-name" class="ml-2">{{$t("user_modal.label_name")}}</label>
                    <b-form-input v-model="userName" type="text" :state="validation_name" id="placeholder-installer-name" :placeholder="'* '+$t('user_modal.placeholder_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_name">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>        
            <b-col sm="5" v-if="type_anag=='person'">
                <b-form-group>
                    <label for="label-surname" class="ml-2">{{$t("user_modal.label_surname")}}</label>
                    <b-form-input v-model="userSurname" type="text" :state="validation_surname" id="placeholder-installer-surname" :placeholder="'* '+$t('user_modal.placeholder_surname')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_surname">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group v-if="type_anag=='company'">
                    <label for="label-business-name" class="ml-2">{{$t("user_modal.label_business_name")}}</label>
                    <b-form-input v-model="userbusinessName" type="text" :state="validation_userbusinessName" id="placeholder-installer-business-name" :placeholder="$t('user_modal.placeholder_business_name')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userbusinessName">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>     
            <b-col sm="10" class="mr-1">
                <b-form-group v-if="type_anag=='company'">
                    <label for="label-piva" class="ml-2">{{$t("user_modal.label_piva")}}</label>
                    <b-form-input v-model="userPiva" type="text" :state="validation_userPiva" id="placeholder-installer-piva" :placeholder="$t('user_modal.placeholder_piva')"></b-form-input>
                    <b-form-invalid-feedback :state="validation_userPiva">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group>
                    <label for="label-phone" class="ml-2">{{$t("user_modal.label_phone")}}</label>
                    <b-form-input v-model="userPhone" type="text" id="placeholder-installer-phone"></b-form-input>
                    <b-form-invalid-feedback>{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="10" class="mr-1">
                <b-form-group>
                    <label for="label-email" class="ml-2">{{$t("signup.emailAddress")}}</label>
                    <b-form-input v-model="userEmail" type="text" :state="validation_email" id="placeholder-installer-mail"></b-form-input>
                    <b-form-invalid-feedback :state="validation_email">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-street" class="ml-2">{{$t("user_modal.label_street")}}</label>
                <b-form-input v-model="userStreet" type="text" :state="validation_userStreet" id="placeholder-installer-street"></b-form-input>
                <b-form-invalid-feedback :state="validation_userStreet">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-number" class="ml-2">{{$t("user_modal.label_number")}}</label>
                <b-form-input v-model="userNumber" type="text" :state="validation_userNumber" id="placeholder-installer-number" ></b-form-input>
                <b-form-invalid-feedback :state="validation_userNumber">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-city" class="ml-2">{{$t("user_modal.label_city")}}</label>
                <b-form-input v-model="userCity" type="text" :state="validation_userCity" id="placeholder-installer-city"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCity">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-cap" class="ml-2">{{$t("user_modal.label_cap")}}</label>
                <b-form-input v-model="userCap" type="text" :state="validation_userCap" id="placeholder-installer-cap"></b-form-input>
                <b-form-invalid-feedback :state="validation_userCap">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="7">
              <b-form-group>
                <label for="label-installer-prov" class="ml-2">{{$t("user_modal.label_prov")}}</label>
                <b-form-input v-model="userProv" type="text" :state="validation_userProv" id="placeholder-installer-prov"></b-form-input>
                <b-form-invalid-feedback :state="validation_userProv">{{$t("user_modal.validation_null")}}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mr-1">
              <b-form-group>
                <label for="label-installer-country" class="ml-2">{{$t("user_modal.label_country")}}</label>
                <b-form-select v-model="userCountry" :country="country" >
                    <option :value="null">{{$t("user_modal.placeholder_country")}}</option>        
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </b-form-select> 
              </b-form-group>
            </b-col>
            </b-row>   
            <b-row>
               <b-col cols="12">
                  <label class="typo-littleblack">{{$t("user_modal.fields")}}</label> 
               </b-col>    
            </b-row>    
            <label v-if="showInformativa()==false" class="typo-color-label mt-4">Prendi visione e accetta l'atto di nomina</label> 
            <b-row v-if="showInformativa()==false" >
               <b-col cols="11">
                 <div class="border p-3">
                  <accettazione-nomina-ITA v-if="$t('language')=='IT'"></accettazione-nomina-ITA>
                  <accettazione-nomina-ENG v-else></accettazione-nomina-ENG>
                  <label for="id_chk" class="float-right typo-color-label mr-5">Accetta la nomina</label>
                  <input type="checkbox" class="float-right mr-3 mt-1" id="chk_nomina" v-model="nomina_checked">
                  <br>
                 </div> 
               </b-col>    
            </b-row>   

          </b-form-group>
        </div>
 
    </b-modal>

    <!-- modal dati aggiornati or error -->
    <b-modal ref="modal-saved" 
      hide-header
      no-close-on-backdrop
      ok-only
      centered
      @ok="SavedData">
    <div class="d-block text-center p-5">
      <i v-if="this.savedMessage==this.$t('manage_client_modal.saved_data')" class="fa fa-check fa-2x" style="color:green"></i>
      <i v-else-if="this.savedMessage==this.$t('manage_client_modal.select_option')" class="fa fa-info-circle fa-2x" style="color:#009DE0"></i>
      <i v-else class="fa fa-exclamation-triangle fa-2x" style="color:red"></i>
      <span class="p-3 h6">{{this.savedMessage}}</span>
    </div>
  </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as consts from '../constants.js';
import AccettazioneNominaITA from '@/locales/AccettazioneNominaITA';
import AccettazioneNominaENG from '@/locales/AccettazioneNominaENG'

export default {
  name: "ManageClient",
   components: {
        AccettazioneNominaITA,
        AccettazioneNominaENG,
    },
  data() {
    return {
      
      footer_hide: false,
      nomina_checked:false,
      picked_client: "",
      savedMessage:"",
      mailInvitato: "",
      roleInvitato: "client",
      type_anag:"company",
      userEmail: '',
      userPiva:'',
      userPhone:'',
      userStreet:'',
      userNumber:'',
      userCity:'',
      userCap:'',
      userProv:'',
      userbusinessName:'',
      userName: '',
      userSurname: '',
      userCountry:"IT",
      country: null,
      saveSubmit:false,
      saveEnabled: true,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/  

    };
  },
  computed: {

   validation_name() {
      if (this.saveSubmit == true) return (this.userName.length > 0 && /^((?![_./]).)*$/.test(this.userName));
      
    },
   validation_surname() {
      if (this.saveSubmit == true) return (this.userSurname.length > 0 && /^((?![_./]).)*$/.test(this.userSurname));
      
    },
   validation_email() {
      if (this.saveUser == true) 
      {
        if(this.userEmail.length>0 && this.reg.test(this.userEmail))
         return true
        else
         return false 
      }  
      
  },
      validation_userbusinessName() {
                if(this.saveSubmit==true) return (this.userbusinessName.length > 0 && /^((?![_]).)*$/.test(this.userbusinessName));
                console.log("userBusiness: " ,this.userbusinessName);
            },
        validation_userStreet() {
                if(this.saveUser==true) return this.userStreet.length > 0
            },
        validation_userPiva() {
                if(this.saveSubmit==true) return this.userPiva.length > 7 && this.userPiva.length < 13
                console.log("userPiva: " ,this.userPiva);
            },
        validation_userPhone() {
                if(this.saveUser==true) return this.userPhone.length > 0
            },
        validation_userNumber() {
                if(this.saveUser==true) return this.userNumber.length > 0
            },
        validation_userCity() {
                if(this.saveUser==true) return this.userCity.length > 0
            },  
        validation_userCap() {
                if(this.saveUser==true) return this.userCap.length > 0
            },   
        validation_userProv() {
                if(this.saveUser==true) return this.userProv.length > 0
            },    
        validation_userCountry() {
                if(this.saveUser==true) return this.userCountry.length > 0
            }
  },
  methods: {
      handleModal(bvModalEvt) {
        this.$root.$emit("bv::show::modal",'modal-manage-client');
      },
      async handleOk(bvModalEvt) {
        console.log("picked client:", this.picked_client);
        bvModalEvt.preventDefault();
    
        if (this.picked_client=="Admin") {
          this.saveEnabled = false;
          console.log("currentPlant:",this.$store.state.currentPlant);

          try {
            var risposta = await this.$store.dispatch('aggiornaClienteImpianto', {mode:'installer',plantId: this.$store.state.currentPlant.id});
            console.log("risposta:",risposta);
            this.saveEnabled = true;
            if (risposta.error) {
              this.savedMessage=this.$t("manage_client_modal.saved_error");
              this.$refs['modal-saved'].show();
            } else 
              {
                this.savedMessage=this.$t("manage_client_modal.saved_data");
                this.$refs['modal-saved'].show();
              }
          } catch (err) {
            this.saveEnabled = true;
            this.savedMessage=this.$t("manage_client_modal.saved_error");
            this.$refs['modal-saved'].show();
          }

        } 
        else if (this.picked_client=="Anag") {
          this.saveSubmit=true;

          console.log("Anagrafica ",this.type_anag,this.userbusinessName);

          if (this.type_anag == 'company') {
             console.log("userBusiness: " ,this.userbusinessName);
            if (!this.validation_userbusinessName || !this.validation_userPiva) {
              return;
            }
          } else {
            if (!this.validation_name || !this.validation_surname) {
              return;
            }
          }

          var cliente = {
            type: this.type_anag,
            businessname: (this.type_anag == 'company') ? this.userbusinessName : "",
            name: (this.type_anag == 'company') ? "" : this.userName,
            surname: (this.type_anag == 'company') ? "" : this.userSurname,
            piva: (this.type_anag == 'company') ? this.userPiva : "",
            phone:  this.userPhone || "",
            email: this.userEmail || "",
            address: {
              "country": this.userCountry,
              "cap": this.userCap,
              "prov": this.userProv,
              "housenumber": this.userNumber,
              "city": this.userCity,
              "street": this.userStreet
            }
          }
          console.log("cliente:",cliente);
          console.log("Show informativa: ",this.showInformativa());

          if (this.showInformativa()==true && this.nomina_checked==false)
          {
              console.log("Nomina not accepted");
              
          }
          else if (this.nomina_checked==true)
          {
            var actualDate=new Date();
            console.log("Dispatch accettazione nomina",actualDate);
            this.$store.dispatch('dbSaveNomina',{acceptedDate: actualDate});
          }

          try {

            var risposta = await this.$store.dispatch('aggiornaClienteImpianto', {mode:'form',plantId: this.$store.state.currentPlant.id, datiCliente: cliente});
            console.log("risposta:",risposta);
            this.saveEnabled = true;
            if (risposta.error) {
                this.saveEnabled = true;
                this.savedMessage=this.$t("manage_client_modal.saved_error");
                this.$refs['modal-saved'].show();
           } else {
                this.saveEnabled = true;
                this.savedMessage=this.$t("manage_client_modal.saved_data");
                this.$refs['modal-saved'].show();
            }

          } catch (err) {
                this.saveEnabled = true;
                this.savedMessage=this.$t("manage_client_modal.saved_error");
                this.$refs['modal-saved'].show();
          }


        } else {
                this.saveEnabled = true;
                this.savedMessage=this.$t("manage_client_modal.select_option");
                this.$refs['modal-saved'].show();
        }

        
      },
        SavedData()
        {
          if(this.savedMessage!=this.$t('manage_client_modal.select_option'))
             this.$store.dispatch('loadPlantDetails',this.$store.state.currentPlant.id);
        },
        showInformativa()
        {
            console.log("State nomina user: " , this.$store.state.user);
            var acceptedDate= new Date(this.$store.state.user.nominaAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("Nomina già accettata in data",acceptedDate);
                return true
            }
            else
            {
               console.log("Nomina non accettata in data",acceptedDate);
               return false
            }    
        },
  }
};
</script>
